export const UPDATE_LOAN_FILTER_FORM_DATA = "UPDATE_LOAN_FILTER_FORM_DATA";
export const updateLoanFilterFormData = formData => ({
  type: UPDATE_LOAN_FILTER_FORM_DATA,
  formData
});
